import { CloseOutlined } from "@ant-design/icons";
import Drawer from "@common/Drawer";

export default function DrawerForm({ label, isOpen, onClose, content }) {
  //handle click on close
  const handleClose = () => {
    onClose();
  };
  return (
    <Drawer open={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4">
        {/* header */}
        <div className="flex items-center justify-between">
          <label className="text-base font-semibold text-primary-tint">
            {label}
          </label>
          <CloseOutlined
            className="!text-text-tint !h-4 cursor-pointer !w-4"
            onClick={handleClose}
          />
        </div>

        {/* input fields */}
        <div>{content}</div>
      </div>
    </Drawer>
  );
}
